import {create} from "zustand";

interface yearTypeState {
  yearValue: number;
  yearString: string;
  setYearValue: (value: number) => void;
  setYearString: (value: string) => void;
  yearList: string[];
  yearCompValue: number[];
  setYearCompValue: (value: number[]) => void;
}

const useYearType = create<yearTypeState>((set) => ({
  yearValue: 0,
  yearString: " 2016-2026",
  setYearValue: (value) => set((state) => ({yearValue: value})),
  setYearString: (value) => set((state) => ({yearString: value})),
  yearList: [
    "2016-2026",
    "2016",
    "2017",
    "2018",
    "2019",
    "2020",
    "2021",
    "2022",
    "2023",
    "2024",
    "2025",
    "2026"
  ],
  yearCompValue: [0, 1],
  setYearCompValue: (value: number[]) => set(() => ({yearCompValue: value})),
}));
export default useYearType;
